import store from "../store";

export const loginMiddle = {
  data() {
    return {
      data_response: [],
      view_permissions: [0, 0, 0, 0],
    };
  },
  methods: {
    getCookie(cname) {
      var name = cname + "=";
      var dCookie = document.cookie;
      var ca = dCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    checkPermissionOnZero(permissions) {
      return (
        permissions[0] == 0 &&
        permissions[1] == 0 &&
        permissions[2] == 0 &&
        permissions[3] == 0
      );
    },
    checkViewMonitoring() {
      // key: url-service, monitoring, mesh_deep_permission
      let permisos = store.state.loginData || {};
      
      // Validaciones defensivas
      if (!permisos || !permisos.roles || permisos.roles.length === 0) {
        return "error";
      }
      
      if (permisos.roles[0] && permisos.roles[0].admin === true) {
        return "Admin";
      }
      
      // Validar que permission existe y tiene la estructura esperada
      if (!permisos.roles[0].permission || 
          permisos.roles[0].permission.length === 0 ||
          !permisos.roles[0].permission[0] ||
          !permisos.roles[0].permission[0].url) {
        return "sin definir";
      }
      
      let permision = permisos.roles[0].permission[0].url.componente || "sin definir";
      return permision;
    },
    checkStorePermissions(view_name) {
      // verifica los permisos de acuerdo al nombre de la vista
      let logindata = store.state.loginData;
      let defaul_permissions = [0, 0, 0, 0];
      

      
      if (!logindata || !logindata.roles || logindata.roles.length === 0) {

        return defaul_permissions;
      }
      
      let isAdmin = logindata.roles.length === 1 && logindata.roles[0].admin === true;
      
      if (isAdmin) {

        defaul_permissions = [1, 1, 1, 1];
      } else {
        let roles = logindata.roles || [];


        if (view_name != undefined) {
          roles.forEach((rol, index) => {

            if (rol && rol.permission && rol.permission.length > 0) {

              // Filtrar elementos null antes de procesar
              const validPermissions = rol.permission.filter(perm => perm !== null);

              
              if (validPermissions.length === 0) {

                return; // Saltar este rol
              }
              
              validPermissions.forEach((viewPermission, permIndex) => {
                if (viewPermission && 
                    viewPermission !== null &&
                    viewPermission.url && 
                    viewPermission.url.componente && 
                    viewPermission.url.componente["url-service"] &&
                    Array.isArray(viewPermission.url.componente["url-service"])) {
                  

                  viewPermission.url.componente["url-service"].forEach((view, viewIndex) => {

                    if (view && view[view_name] != undefined) {

                      defaul_permissions = view[view_name];
                    }
                  });
                } else {
                  console.log('Estructura de permisos no válida o faltante');
                }
              });
            } else {
              console.log('Rol sin permisos válidos');
            }
          });
        }
      }
      
      // Si no se encontraron permisos específicos pero el usuario tiene rol "Cliente"
      if (defaul_permissions[0] === 0 && defaul_permissions[1] === 0 && 
          defaul_permissions[2] === 0 && defaul_permissions[3] === 0) {
        
        // Verificar si es un cliente sin permisos configurados
        const isClient = logindata.roles.some(rol => rol.name === 'Cliente' || rol.name === 'cliente');
        if (isClient) {

          defaul_permissions = [1, 1, 1, 1]; // Lectura, creación, actualización y eliminación para clientes
        }
      }
      

      return defaul_permissions;
    },
  },
};
export default loginMiddle;
